import React, { useContext, useEffect, useState } from 'react'
import { DContext } from '../../context/Datacontext'
import { useNavigate, useParams } from 'react-router-dom'
import { fetchGetUsers, updateUsers } from '../services/fetchGetUser'
import { fetchManager } from '../services/fetchManager'
import { fetchTeamLead } from '../services/fetchTeamLead'
import InputRegister from '../blocks/ui/InputDesign'
import placeholder from '../../assets/profile picture.png'
import { confirmPasswordValidator, contactValidator, emailValidator, firstNameValidator, fullNameValidator, lastNameValidator, passwordValidator } from '../../utils/validator'
import { compressImage } from '../../utils/compressImages'
import { renderImgSrc } from '../../utils/renderImage'


export default function Account() {

    const { BeURL, currentUser, showAlert } = useContext(DContext)

    const [users, setUsers] = useState(null)
    const navigate = useNavigate()

    const [errors, setErrors] = useState({ users: {} })
    const [password, setPassword] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    })

    const [confirmChange, setConfirmChange] = useState(false)

    useEffect(() => {
        try {
            const fetchUser = async () => {
                await fetchGetUsers(BeURL, showAlert, setUsers, currentUser?.id)
            }
            fetchUser()
        }
        catch (err) {
            console.error("Error in fetch User Data :", err)
        }

    }, [BeURL, currentUser])

    const handlePassword = (name, value) => {
        setPassword((prev) => ({ ...prev, [name]: value }));

        let errorMsg = '';
        switch (name) {
            case "currentPassword":
                errorMsg = passwordValidator(value);
                break;
            case "newPassword":
                errorMsg = passwordValidator(value);
                break;

            case "confirmPassword":
                errorMsg = confirmPasswordValidator(value, password.newPassword);
                break;

            default:
                break;
        }
        // Update error state
        setErrors((prev) => ({
            ...prev,
            users: {
                ...prev.users,
                [name]: errorMsg,
            },
        }));
    }


    const isFormValid = (errors) => {
        // Check if all error objects are empty
        return (
            Object.values(errors.users || {}).every((err) => !err)
        )
    }


    const handleUpdate = () => {
        // Users
        const formData1 = new FormData()

        if (password) {
            formData1.append('currentPassword', password.currentPassword)
            formData1.append('password', password.newPassword)
        }

        updateUsers(BeURL, showAlert, formData1, users.id, navigate)

    }
    return (
        <main className='px-4 md:px-8 lg:px-16 xl:px-24 py-10 '>
            <section>
                <div className=" rounded-lg shadow-lg px-6 py-2">

                    <h2 className='text-xl font-semibold text-primary-400 p-4'>Users Details </h2>


                    <div className={`flex items-center text-left gap-4 mt-2 cursor-pointer`}>
                        <input type='checkbox' className='' id="change-password" onChange={() => setConfirmChange(!confirmChange)} /><label htmlFor='change-password' className="text-sm font-medium text-gray-600 mb-1 cursor-pointer">Change Password</label>
                    </div>

                    {confirmChange && <><div className={`grid grid-cols-1  md:grid-cols-3 gap-4 mt-2`}>

                        {[
                            {
                                label: "Current Password", name: "currentPassword", value: password.currentPassword, error: errors.users?.currentPassword, mandatory: true, required: true
                            },
                            { label: "New Password ", name: "newPassword", value: password.newPassword, error: errors.users?.newPassword, mandatory: true, required: true }, ,
                            { label: "Confirm Password ", name: "confirmPassword", value: password.confirmPassword, error: errors.users?.confirmPassword, mandatory: true, required: true },

                        ].map((field, idx) => (
                            <div className='bg-gray-50 p-4 rounded-xl shadow-inner'>
                                <InputRegister
                                    key={idx} empId
                                    label={field.label}
                                    value={field.value}
                                    name={field.name}
                                    mandatory={field.mandatory}
                                    required={field.required}
                                    placeholder={field.label}
                                    type="password"
                                    className="min-w-full md:w-full"
                                    error={field.error}
                                    onChange={(e) =>
                                        handlePassword(e.target.name, e.target.value)
                                    }
                                /></div>)
                        )}
                    </div>

                        <div className="md:col-span-2 flex justify-end my-4">
                            <button
                                type="submit"
                                disabled={!isFormValid(errors)}
                                className={`px-4 py-2 rounded ${isFormValid(errors)
                                    ? "bg-primary-200 text-white hover:bg-primary-500"
                                    : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
                                onClick={handleUpdate}
                            >
                                Update Password
                            </button>
                        </div>
                    </>
                    }

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">

                        {[
                            {
                                label: "First Name", name: "firstName", value: users?.firstName, mandatory: true,
                                required: true
                            },
                            users?.lastName && { label: " Last Name", name: "lastName", value: users?.lastName, }
                        ].filter(Boolean).map((field, idx) => (
                            <div className='bg-gray-50 p-4 rounded-xl shadow-inner  '>
                                <InputRegister
                                    key={idx}
                                    label={field.label}
                                    value={field.value}
                                    name={field.name}

                                    required={field.required}
                                    placeholder={field.label}
                                    type="text"
                                    className="min-w-full md:w-full border border-gray-300  bg-gray-100 text-gray-700 rounded-lg px-3 py-2 
                                     cursor-default outline-none focus:outline-none focus:ring-0 focus:border-gray-300 select-none"
                                    readOnly

                                />
                            </div>
                        ))}

                        {[
                            {
                                label: "Full Name", name: "fullName", value: users?.fullName, error: errors.users?.fullName, mandatory: true,
                                required: true
                            },
                            {
                                label: " Email", name: "email", value: users?.email, error: errors.users?.email, mandatory: true,
                                required: true
                            },
                            users?.alternateEmail && { label: " Alternate Email", name: "alternateEmail", value: users?.alternateEmail, error: errors.users?.alternateEmail },
                        ].filter(Boolean).map((field, idx) => (
                            <div className='bg-gray-50 p-4 rounded-xl shadow-inner'>
                                <InputRegister
                                    key={idx}
                                    label={field.label}
                                    value={field.value}
                                    name={field.name}

                                    required={field.required}
                                    placeholder={field.label}
                                    type="text"
                                    className="min-w-full md:w-full border border-gray-300  bg-gray-100 text-gray-700 rounded-lg px-3 py-2 
                                     cursor-default outline-none focus:outline-none focus:ring-0 focus:border-gray-300 select-none"
                                    error={field.error}
                                    readOnly
                                />
                            </div>
                        ))}


                        {[
                            {
                                label: "Contact Number",
                                name: "contact",
                                value: users?.contact,
                                error: errors.users?.contact,
                                mandatory: true,
                                required: true
                            },
                            users?.alternateContact?.trim() && {
                                label: "Alternate Contact Number",
                                name: "alternateContact",
                                value: users?.alternateContact,

                            },
                            users?.employementId?.trim() && {
                                label: "Employement Id ", name: "employementId", value: users?.employementId,
                            }

                        ].filter(Boolean).map((field, idx) => (
                            <div className='bg-gray-50 p-4 rounded-xl shadow-inner'>
                                <InputRegister
                                    key={idx}
                                    label={field.label}
                                    value={field.value}
                                    name={field.name}
                                    mandatory={field.mandatory}
                                    required={field.required}
                                    placeholder={field.label}
                                    type="text"
                                    className="min-w-full md:w-full border border-gray-300  bg-gray-100 text-gray-700 rounded-lg px-3 py-2 
                                     cursor-default outline-none focus:outline-none focus:ring-0 focus:border-gray-300 select-none"
                                    error={field.error}
                                    readOnly
                                />
                            </div>
                        ))}



                        <div className={`pt-1 bg-gray-50 p-4 rounded-xl shadow-inner ${currentUser.role === 'teamlead' ? 'hidden' : 'block'} `}>
                            <label className="block text-sm font-medium text-gray-600 mb-1">
                                Role<sup className="text-red-500 text-sm">*</sup>
                            </label>
                            <InputRegister
                                value={users?.role}
                                // name={field.name}     
                                type="text"
                                className="min-w-full md:w-full border border-gray-300  bg-gray-100 text-gray-700 rounded-lg px-3 py-2 
                                     cursor-default outline-none focus:outline-none focus:ring-0 focus:border-gray-300 select-none"
                            />
                            {/* {errors.users?.role && < p class="text-sm text-red-500 mt-1 hidden">Role is Required</p>} */}
                        </div>

                        {
                            (users?.role === 'teamlead' || users?.role === 'recruiter') &&
                            <div className='pt-1 bg-gray-50 p-4 rounded-xl shadow-inner'>
                                <label className="block text-sm font-medium text-gray-600 mb-1">
                                    Reporting Manager<sup className="text-red-500 text-sm">*</sup>
                                </label>
                                <InputRegister
                                    value={users?.reportingManager.reportingManagerName}
                                    // name={field.name}     
                                    type="text"
                                    className="min-w-full md:w-full border border-gray-300  bg-gray-100 text-gray-700 rounded-lg px-3 py-2 
                                     cursor-default outline-none focus:outline-none focus:ring-0 focus:border-gray-300 select-none"
                                    readOnly
                                />
                            </div>

                        }

                        {(users?.role === 'recruiter') &&

                            <div className='bg-gray-50 p-4 rounded-xl shadow-inner'>
                                <label className="block text-sm font-medium text-gray-600 mb-1">
                                    Reporting Team Lead<sup className="text-red-500 text-sm">*</sup>
                                </label>
                                <InputRegister
                                    value={users?.reportingTeamLead.reportingTeamLeadName}
                                    // name={field.name}     
                                    type="text"
                                    className="min-w-full md:w-full border border-gray-300  bg-gray-100 text-gray-700 rounded-lg px-3 py-2 
                                     cursor-default outline-none focus:outline-none focus:ring-0 focus:border-gray-300 select-none"
                                    readOnly
                                />
                            </div>

                        }
                    </div>

                </div>
            </section>

            {currentUser?.role === 'admin' && <section>

            </section>}
        </main>

    )
}
